var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6992 12.6797C24.6992 6.04969 19.3292 0.679688 12.6992 0.679688C6.06922 0.679688 0.699219 6.04969 0.699219 12.6797C0.699219 18.2997 4.57932 23.0297 9.79932 24.3297V16.3497H7.31921V12.6797H9.79932V11.0997C9.79932 7.01969 11.6493 5.11969 15.6593 5.11969C16.4193 5.11969 17.7293 5.26969 18.2693 5.41969V8.73969C17.9893 8.70969 17.4993 8.68969 16.8793 8.68969C14.9093 8.68969 14.1493 9.43969 14.1493 11.3697V12.6697H18.0692L17.3993 16.3397H14.1493V24.5897C20.0893 23.8697 24.6992 18.8097 24.6992 12.6797Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookW);
export default __webpack_public_path__ + "static/media/facebook_w.2bbd718ce2dc93e4218c50baac529097.svg";
export { ForwardRef as ReactComponent };